var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNmrLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 87,
    viewBox: "0 0 137 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 134.281,
    height: 85,
    fill: "#0C0C31",
    stroke: "#C3FA50",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1308_1530)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.615,
    height: 72.625,
    transform: "translate(16.6973 6.32227)",
    fill: "#0C0C31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3226 30.4589V59.4747H38.5243C38.154 59.4836 37.7863 59.4105 37.448 59.2607C37.1105 59.0844 36.8164 58.8359 36.587 58.5332L21.3468 39.2321C21.3468 40.0881 21.3468 40.9012 21.3468 41.6715V59.4747H16.6973V30.4589H20.1414C20.2816 30.416 20.4316 30.416 20.5719 30.4589L21.0024 30.8869C21.1524 31.0094 21.283 31.1537 21.3899 31.3149L36.7161 50.7443V49.3748C36.7161 48.9041 36.7161 48.4761 36.7161 48.0909V30.4589H41.3226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.312 59.4751H116.103C115.677 59.5024 115.252 59.4082 114.878 59.2034C114.505 58.9987 114.197 58.6921 113.993 58.3196L107.449 48.4765C107.285 48.1408 107.012 47.8696 106.674 47.7062C106.273 47.5129 105.828 47.4246 105.383 47.4494H102.8V59.4751H97.1602V28.7047H106.588C108.418 28.6702 110.243 28.8862 112.013 29.3467C113.363 29.6963 114.624 30.3232 115.715 31.1869C116.644 31.9219 117.37 32.879 117.825 33.9687C118.305 35.1059 118.539 36.3305 118.514 37.5635C118.514 38.5526 118.354 39.5352 118.04 40.4737C117.759 41.383 117.322 42.2372 116.748 42.9986C116.149 43.7721 115.421 44.4379 114.596 44.9673C113.7 45.5756 112.711 46.0379 111.668 46.3367C112.037 46.5441 112.383 46.7878 112.702 47.0643C113.034 47.3665 113.324 47.712 113.563 48.0914L121.312 59.4751ZM106.502 43.341C107.464 43.3574 108.422 43.2275 109.344 42.9558C110.102 42.7287 110.805 42.3501 111.41 41.8431C111.912 41.3582 112.308 40.7754 112.573 40.1313C112.837 39.4488 112.968 38.7227 112.96 37.9915C113.008 37.313 112.892 36.6329 112.622 36.0078C112.353 35.3826 111.937 34.8303 111.41 34.3966C110.027 33.4395 108.355 32.986 106.674 33.1127H102.8V43.341H106.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0556 56.2227H41.3223V59.4752H55.0556V56.2227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.422 56.2227H87.6885V59.4752H101.422V56.2227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3177 36.8357L59.4038 39.1467L55.1417 59.4748L51.5254 58.6189L57.079 32.1709L59.3177 36.8357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1889 25.0246L58.8875 23.8691L56.9502 32.5995L65.6035 68.5483L69.2629 67.4356L59.1889 25.0246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1004 78.9473L67.5407 76.6363L65.6465 68.719L75.29 6.32227L77.1412 21.3437L68.1004 78.9473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1526 59.475L89.8415 59.0899L75.2901 6.32227L74.7305 17.5776L85.3641 59.475H89.1526Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1308_1530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.615,
    height: 72.625,
    fill: "white",
    transform: "translate(16.6973 6.32227)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmrLogo);
export default __webpack_public_path__ + "static/media/NMR Logo.77855734de215fbe01f9bc0c4db6b456.svg";
export { ForwardRef as ReactComponent };